<div class="wrapper">
  <div class="main">

    <!--topbar-->
    <div class="top-bar d-flex flex-column justify-content-start align-items-start flex-md-row align-items-md-center justify-content-md-between">

      <!--USER ICON-->
      <div class="col-12 col-md d-flex align-items-center justify-content-between top-bar-left">
        <div class="top-bar-user d-flex align-items-center">
          <div class="user-icon">
            <i class="far fa-user-circle"></i>
          </div>
          <div class="user ml-2">
            <p class="top-bar-user-username mb-0" title="{{principal.user?.name}}">{{principal.user?.name}}</p>
            <small class="top-bar-user-partner mb-0" title="{{principal.demandPartner?.displayName || principal.demandPartner?.name}}">{{principal.demandPartner?.displayName || principal.demandPartner?.name}}</small>
          </div>
        </div>
        <div class="top-bar-mobile-controls d-flex align-items-center d-md-none">
          <button mat-icon-button color="primary" (click)="mobileMenu=!mobileMenu">
            <i class="fas fa-bars" aria-hidden="true"></i>
          </button>
          <button mat-icon-button matTooltip="Support" color="primary"
                  routerLink="/support"
                  routerLinkActive="active">
            <i class="far fa-life-ring"></i>
          </button>
          <button mat-icon-button matTooltip="Logout" color="primary"
                  (click)="logout()">
            <i class="far fa-sign-out"></i>
          </button>
        </div>
      </div>

      <!--MENU-->
      <div class="col-12 col-md-auto d-md-block" [ngClass]="mobileMenu ? 'd-block' : 'd-none'">
        <nav  class="top-bar-menu" [ngClass]="mobileMenu ? 'open' : 'closed'">
          <a [routerLink]="'/dashboard'"
             routerLinkActive #rla1="routerLinkActive"
             [class.active]="rla1.isActive"
             (click)="mobileMenu=!mobileMenu">
            <i class="far fa-tachometer" aria-hidden="true"></i>
            <span>Dashboard</span>
          </a>
          <a [routerLink]="'/blocklist'"
             routerLinkActive #rla12="routerLinkActive"
             [class.active]="rla12.isActive"
             (click)="mobileMenu=!mobileMenu">
            <i class="far fa-shield-alt" aria-hidden="true"></i>
            <span>Block list</span>
          </a>
          <!--<a [routerLink]="'/ads-txt'"-->
             <!--routerLinkActive #rla3="routerLinkActive"-->
             <!--[class.active]="rla3.isActive"-->
             <!--(click)="mobileMenu=!mobileMenu">-->
            <!--<i class="far fa-file-alt"></i>-->
            <!--<span>Ads.txt</span>-->
          <!--</a>-->
        </nav>
      </div>

      <!--ACTIONS-->
      <div class="col-12 col-md d-none d-md-block top-bar-right">
        <div class="top-bar-controls text-right pr-3">
          <button mat-icon-button matTooltip="Support" color="primary"
                  routerLink="/support"
                  routerLinkActive="active">
            <i class="far fa-life-ring"></i>
          </button>
          <button mat-icon-button matTooltip="Logout" color="primary"
                  (click)="logout()">
            <i class="far fa-sign-out"></i>
          </button>
        </div>
      </div>

    </div>

    <router-outlet></router-outlet>
  </div>
</div>
